import React from "react";
import PropTypes from "prop-types";

import _ from "lodash";

import Table from "../../Common/Table";
import Row from "../../Common/Row";
import {useSelector} from "react-redux";
import NotFound from "../../Common/NotFound";
import ConnectedServicesRows from "../../Common/Rows/ConnectedServicesRows";
import OwnerShipRows from "../../Common/Rows/OwnerShipRows";
import EntitlementRows from "../../Common/Rows/EntitlementRows";
import VehicleAddedRows from "../../Common/Rows/VehicleAddedRows";

const Rows = ({customer, privacy}) => {
    return (
        <>
            <Row label={`Uuid`} value={customer.uuid}/>
            <Row label={`Email`} value={_.get(customer, `details.email`)}/>
            <Row label={`Locale`} value={_.get(customer, `details.culture`)}/>
            <VehicleAddedRows addedOn={customer.createdOn} addedBy={customer.createdBy}
                              modifiedOn={customer.modifiedOn}/>
			<OwnerShipRows claimedOn={customer.claimedOn} isOwner={customer.isOwner} claimedBy={customer.claimedBy}/>
            <EntitlementRows claimedOn={customer.entitledOn} entitled={customer.isEntitled}
                             claimedBy={customer.entitledBy}/>
            <ConnectedServicesRows connectedStatus={customer.connectedServiceStatus} privacy={privacy}/>
        </>
    );
};

const CustomerDetails = () => {
    const vehicle = useSelector(state => state.vehicle.cp);
    const privacy = useSelector(state => state.vehicle.privacy);

    return (
        <div className="row">
            {
                _.some(vehicle.users) ? (
                    vehicle.users.map((customer, index) => {
                        return (
                            <div className="col-xs-6" key={index}>
                                <Table
                                    title={`Vehicle details - ${customer.alias}`}
                                    icon={`fa fa-car`}
                                    colorClass={customer.isOwner ? `customer-owner` : `customer-not-owner`}
                                    iconHoverText=
                                        {`Customer is ${!customer.isOwner ? `not ` : ``}the owner of this vehicle`}
                                >
                                    <Rows customer={customer} privacy={privacy}/>
                                </Table>
                            </div>
                        );
                    })
                ) : (
                    <NotFound>No customers linked to this vehicle...</NotFound>

                )
            }
        </div>
    );
};
CustomerDetails.displayName = `Details`;
CustomerDetails.propTypes = {
    customer: PropTypes.object.isRequired
};

Rows.displayName = `Rows`;
Rows.propTypes = {
    customer: PropTypes.object.isRequired,
    privacy: PropTypes.object.isRequired
};

export default CustomerDetails;
